<template>
  <v-expansion-panel class="elevation-0" focusable>
    <v-expansion-panel-content v-for="section in inspection.jsonResult" :key="section.id">
      <template v-slot:header>
        <v-layout row wrap>
          <v-flex xs6 :class="reportIssues(section)? 'Issues':'OK'">
            {{ section.title }}
          </v-flex>
          <v-flex xs6 text-xs-right>
            <span class="pr-4" :class="reportIssues(section)? 'Issues':'OK'">
              {{ reportIssues(section)? "Issues":"OK" }}
            </span>
          </v-flex>
        </v-layout>
      </template>
      <div v-if="section.components && Object.keys(section.components).length > 0">
        <v-list>
          <v-list-tile
            v-for="component in section.components"
            :key="component.id"
            @click="setComponent(component)"
          >
            <v-list-tile-content
              class="flex-direction--row justify-content--left align-items--center"
            >
              <span :class="component.reportIssues? 'Issues':'OK'">{{ component.title }}</span>
              <v-chip small>{{ component.note }}</v-chip>
            </v-list-tile-content>
            <v-list-tile-action class="flex-direction--row">
              <v-icon v-if="component.images && component.images.length > 0">text_snippet</v-icon>
              <v-icon v-if="component.reportIssues">content_paste</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </div>
    </v-expansion-panel-content>
    <HHSComponent :selectedComponent="selectedComponent" :show-component-dialog.sync="showComponentDialog"/>
  </v-expansion-panel>
</template>

<script>
import HHSComponent from './details/HHSComponent.vue'

export default {
  name: 'HHSExpansionPanel',
  components: {
    HHSComponent
  },
  props: {
    inspection: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedComponent: {},
      showComponentDialog: false,
    }
  },
  computed: {
  },
  methods: {
    setComponent(component) {
      this.selectedComponent = component;
      this.showComponentDialog = true;
    },
    reportIssues(section) {
      return !!(section.components.find(c => c.reportIssues));
    }
  },
  mounted() {
    console.log({inspection: this.inspection})
  }
}
</script>

<style scoped>
.flex-direction--row {
  flex-direction: row;
}

.justify-content--left {
  justify-content: left;
}

.align-items--center {
  align-items: center;
}

.Issues {
  color: red;
}

</style>